/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type UpdateVolunteerMutationVariables = Types.Exact<{
  primary_category_name: Types.Scalars["String"];
  min_primary_signups: Types.Scalars["Float"];
  event_attendee_id: Types.Scalars["Int"];
}>;

export type UpdateVolunteerMutation = {
  updateVolunteer: Array<Pick<Types.Volunteer, "event_attendee_id">>;
};

export const UpdateVolunteerDocument = gql`
  mutation UpdateVolunteer(
    $primary_category_name: String!
    $min_primary_signups: Float!
    $event_attendee_id: Int!
  ) {
    updateVolunteer(
      data: {
        primary_category_name: $primary_category_name
        min_primary_signups: $min_primary_signups
      }
      where: { event_attendee_id: { equals: $event_attendee_id } }
    ) {
      event_attendee_id
    }
  }
`;

/**
 * __useUpdateVolunteerMutation__
 *
 * To run a mutation, you first call `useUpdateVolunteerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVolunteerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVolunteerMutation, { data, loading, error }] = useUpdateVolunteerMutation({
 *   variables: {
 *      primary_category_name: // value for 'primary_category_name'
 *      min_primary_signups: // value for 'min_primary_signups'
 *      event_attendee_id: // value for 'event_attendee_id'
 *   },
 * });
 */
export function useUpdateVolunteerMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateVolunteerMutation,
    UpdateVolunteerMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    UpdateVolunteerMutation,
    UpdateVolunteerMutationVariables
  >(UpdateVolunteerDocument, baseOptions);
}
export type UpdateVolunteerMutationHookResult = ReturnType<
  typeof useUpdateVolunteerMutation
>;
export type UpdateVolunteerMutationResult =
  ApolloReactCommon.MutationResult<UpdateVolunteerMutation>;
export type UpdateVolunteerMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateVolunteerMutation,
    UpdateVolunteerMutationVariables
  >;
